import { PurchasesModel } from '@/shared/models/purchases.model';
import { getLocalizedValue } from '@/shared/services/helpers/format-display-label/format-display-label';
import { PurchasesTableDataUiModel } from '@/shared/ui-models/purchase.ui-model';

function mapToUi(purchases: PurchasesModel[]): PurchasesTableDataUiModel[] {
  return purchases?.map((purchase) => {
    return {
      id: purchase.id,
      customer: purchase.user?.name,
      applicationId: purchase.application?.shortId,
      productType: purchase.productType,
      merchant: getLocalizedValue(purchase.merchant?.companyName),
      paymentMethod: purchase.paymentMethod,
      financeOfficer: purchase.financeOfficer?.name,
      createdAt: purchase.createdAt,
      status: purchase.status,
      supplierName: purchase.supplierName,
      product: {
        carBrand: { name: purchase.product?.carBrand.name ?? { en: '', ar: '' } },
        carModel: purchase.product?.carModel ?? { en: '', ar: '' },
        carChassis: purchase.product?.carChassis ?? ''
      }
    };
  });
}

const purchasesTableDataMapper = { mapToUi };

export default purchasesTableDataMapper;
